import { Injectable } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngxs/store";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AccreditationSTEP, CovidTestSTEP, STEP, VaccinationSTEP } from "../../model/steps.model";
import { USECASE } from "../../model/usecase.model";
import {
  setBioSealDocumentContent,
  setBioSealEventContent,
  setBioSealPersonalContent,
  setBioSealPractitionerContent,
  setBioSealTestContent,
  setDocumentFormSubmition,
  setEventFormSubmition,
  setPersonalFormSubmition,
  setPractitionerFormSubmition,
  setTestFormSubmition,
} from "../../store/actions/bioseal.action";
import { DateFormatUtils } from "../../utils/date-format.utils";
import { Sandbox } from "../sandbox";
@Injectable()
export class UserSandbox extends Sandbox {

  today =
    new Date().getFullYear() +
    "-" +
    ("0" + (new Date().getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + new Date().getDate()).slice(-2);

  todayISO = new Date().toISOString();

  expiryDate =
    new Date().getFullYear() +
    1 +
    "-" +
    ("0" + (new Date().getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + (new Date().getDate() - 1)).slice(-2);

  constructor(private store: Store) {
    super(store);
  }

  isPersonalForm(): Observable<boolean> {
    return this.global.pipe(
      map((res) => {
        if (res.useCase === USECASE.GENERIC) {
          return res.step === STEP.USER_FORM_PERSONAL;
        }
        if (res.useCase === USECASE.VACCINATION) {
          return res.step === VaccinationSTEP.USER_FORM_PERSONAL;
        }
        if (res.useCase === USECASE.COVID_TEST) {
          return res.step === CovidTestSTEP.USER_FORM_PERSONAL;
        }
        if (res.useCase === USECASE.ACCREDITATION) {
          return res.step === AccreditationSTEP.USER_FORM_PERSONAL;
        }

      })
    );
  }

  isDocumentForm(): Observable<boolean> {
    return this.global.pipe(
      map((res) => {
        if (res.useCase === USECASE.GENERIC) {
          return res.step === STEP.USER_FORM_DOCUMENT;
        }
        if (res.useCase === USECASE.VACCINATION) {
          return res.step === VaccinationSTEP.USER_FORM_DOCUMENT;
        }
      })
    );
  }

  isPractitionerForm(): Observable<boolean> {
    return this.global.pipe(
      map((res) => {
        return res.step === VaccinationSTEP.USER_FORM_PRACTITIONER;
      })
    );
  }

  isTestForm(): Observable<boolean> {
    return this.global.pipe(
      map((res) => {
        return res.step === CovidTestSTEP.USER_FORM_TEST;
      })
    );
  }

  isEventForm(): Observable<boolean> {
    return this.global.pipe(
      map((res) => {
        return res.step === AccreditationSTEP.USER_FORM_EVENT;
      })
    );
  }

  onPersonalFormSubmitted() {
    this.store.dispatch(new setPersonalFormSubmition())
  }
  onDocumentFormSubmitted() {
    this.store.dispatch(new setDocumentFormSubmition())
  }
  onPractitionerFormSubmitted() {
    this.store.dispatch(new setPractitionerFormSubmition())
  }
  onTestFormSubmitted() {
    this.store.dispatch(new setTestFormSubmition())
  }
  onEventFormSubmitted() {
    this.store.dispatch(new setEventFormSubmition())
  }

  onPersonalFormValid(value) {
    this.store.dispatch(new setBioSealPersonalContent(value));
  }
  onDocumentFormValid(value) {
    this.store.dispatch(new setBioSealDocumentContent(value));
  }
  onPractitionerFormValid(value) {
    this.store.dispatch(new setBioSealPractitionerContent(value));
  }
  onTestFormValid(value) {
    this.store.dispatch(new setBioSealTestContent(value));
  }
  onEventFormValid(value) {
    this.store.dispatch(new setBioSealEventContent(value));
  }

  EmailValidator(confirmEmailInput: string) {
    let confirmEmailControl: FormControl;
    let emailControl: FormControl;
    return (control: FormControl) => {
      if (!control.parent) {
        return null;
      }

      if (!confirmEmailControl) {
        confirmEmailControl = control;
        emailControl = control.parent.get(confirmEmailInput) as FormControl;
        emailControl.valueChanges.subscribe(() => {
          confirmEmailControl.updateValueAndValidity();
        });
      }

      if (
        emailControl.value.toLocaleLowerCase() !==
        confirmEmailControl.value.toLocaleLowerCase()
      ) {
        return {
          notMatch: true,
        };
      }
      return null;
    };
  }

}
